export default {
  '1': '正常',
  '2': '异常',
  '3': '撤销',
}